// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import TableWithSort from '../core/table-with-sort';

// Configs
import servicesConfig from '../../../config/services-config';

// Lib
import actionsServiceCaller from '../../lib/app/actions-service-caller';

// Styles
import './fvod-ordering-table.scss';

import {columnConfig} from './helpers/constant';

class FvodOrderingTable extends Component {
    state = {
        fvodData: [],
        originalData: [],
        fetching: false,
        error: null,
    };

    componentDidMount() {
        this.fetchFvodData();
    }

    getColumnConfig() {
        const {getLockedIndicatorProps, detailLinkPrefix, renderStateAndMapped} = this.props;
        return columnConfig(getLockedIndicatorProps, detailLinkPrefix || '/media-items', renderStateAndMapped);
    }

    getTableWithSortProps() {
        const {fvodData} = this.state;
        return {
            columnConfig: this.getColumnConfig(),
            draggable: true,
            localSort: true,
            noSort: true,
            onDragEnd: this.onDragEnd,
            rowColorCallback: this.rowColorCallback,
            rowDetails: this.getRowDetails(),
            searchData: fvodData,
            sort: [],
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'description',
                'releaseYear',
                'originalAirDate',
                'seasonNumber',
                'episodeNumber',
                'duration',
                'rating',
                'lang',
                'genres',
                'createdBy',
                'lastModifiedBy',
            ],
        };
    }

    rowColorCallback = (dataRow) => {
        return dataRow.fvodOrdered
            ? { color: '#dbffc3', text: 'Ordered' }
            : { color: '#fdcece', text: 'Not Ordered' };
    };

    onDragEnd = (result) => {
        const {destination, source} = result;

        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        this.setState(({fvodData}) => {
            const tempData = JSON.parse(JSON.stringify(fvodData));
            tempData.splice(destination.index, 0, tempData.splice(source.index, 1)[0]);

            return {fvodData: tempData};
        });
    };

    saveOrder = () => {
        const {fvodData} = this.state;
        const mediaItems = fvodData.map(({fvodOrdered, ...item}) => item);
        this.setState({fetching: true, error: null});

        const dispatchFetched = () => {
            this.setState({
                originalData: JSON.parse(JSON.stringify(fvodData)),
                fetching: false,
            });
        };

        const dispatchError = (error) => {
            this.setState({
                error: error?.message || error || 'Failed to save FVOD ordering',
                fetching: false,
            });
        };

        const actionParams = {
            servicesConfig: servicesConfig.fvodOrderingSave,
            dispatchFetched,
            dispatchError,
        };

        actionsServiceCaller(actionParams, {mediaItems});
    };

    cancelOrder = () => {
        this.setState((prevState) => ({
            fvodData: JSON.parse(JSON.stringify(prevState.originalData)),
        }));
    };

    fetchFvodData() {
        this.setState({fetching: true, error: null});

        const dispatchFetched = (data) => {
            const items = data?.mediaItems || [];
            const sorted = this.sortFvodData(Array.isArray(items) ? items : []);
            this.setState({
                fvodData: sorted,
                originalData: JSON.parse(JSON.stringify(sorted)),
                fetching: false,
            });
        };

        const dispatchError = (error) => {
            this.setState({
                error: error?.message || error || 'Failed to fetch FVOD ordering data',
                fetching: false,
            });
        };

        const actionParams = {
            servicesConfig: servicesConfig.fvodOrdering,
            dispatchFetched,
            dispatchError,
        };

        actionsServiceCaller(actionParams);
    }

    sortFvodData(items) {
        const unordered = items.filter((item) => !item.fvodOrdered);
        const ordered = items.filter((item) => item.fvodOrdered);

        if (ordered.length === 0) {
            // All unordered: sort by lastUpdated desc
            return unordered.sort((a, b) => new Date(b.lastUpdated) - new Date(a.lastUpdated));
        }
        if (unordered.length === 0) {
            // All ordered: keep original order from backend
            return ordered;
        }
        // Mixed: unordered at top sorted by lastUpdated desc, ordered at bottom
        unordered.sort((a, b) => new Date(b.lastUpdated) - new Date(a.lastUpdated));
        return [...unordered, ...ordered];
    }

    render() {
        const {fvodData, fetching, error} = this.state;

        return (
            <div className="fvod-ordering-table">
                <Loading loading={fetching} />
                {error && <Error error={error} onClear={() => this.setState({error: null})} />}
                {fvodData.length > 0 && <TableWithSort {...this.getTableWithSortProps()} />}
                {!fetching && !error && fvodData.length === 0 && (
                    <Error error="No FVOD ordering data available." />
                )}
            </div>
        );
    }
}

FvodOrderingTable.propTypes = {
    detailLinkPrefix: PropTypes.string,
    getLockedIndicatorProps: PropTypes.func,
    renderStateAndMapped: PropTypes.func,
};

export default FvodOrderingTable;
